define('modules/editor/views/property_boxes/page_popup',['require','exports','module','./base','fontmanager','ldsh!../../templates/property_boxes/page_popup'],function(require, exports, module){
  "use strict";
  var BasePropertyGroup = require("./base"),
      FontManager = require('fontmanager');

  module.exports = BasePropertyGroup.extend({
    template: require('ldsh!../../templates/property_boxes/page_popup'),

    myEvents: {
      'change .js-range': 'onRangeChange',
    },

    initialize: function(){
      _.extend(this.events, this.myEvents);
      module.exports.__super__.initialize.apply(this,arguments);
    },

    onRender: function() {
      this._updateRangeValue(this.model.get('overlayOpacity'));
    },

    onRangeChange: function(e){
      var value = $(e.currentTarget).val();

      this._updateRangeValue(value);
      this._getPropertyValues();
    },

    _updateRangeValue: function(value){
      this.$(".js-range-value").html(value);
    },

    helpers: function() {
      return {
        fonts: FontManager.getNames()
      };
    }
  });
});

